import { _axios } from '@/plugins/axios';

const SocResource = '/api/v1/soc/threat-spider';

export default {
  getProjectsFromThreatSpider: () => _axios.get(`${SocResource}/projects`),
  getServerUrl: () => _axios.get(`${SocResource}/server-url`),
  getProjectComponentsFromThreatSpider: projectId =>
    _axios.post(`${SocResource}/project-components`, projectId),
  getComponentStandardsFromThreatSpider: componentIds =>
    _axios.post(`${SocResource}/component-standards`, componentIds),
};
